<template>
  <div class="freegoods-container" @click="$router.push({ name: 'FreeGoods' })">
    <div class="left">
      <div class="title">免费抢好货</div>
      <div class="subtitle">精品好货免费抢</div>
      <div class="btn">GO<Icon name="arrow" /></div>
    </div>
    <div class="right">
      <div class="swiper-wrapper">
        <Swipe :show-indicators="false" :autoplay="3000">
          <SwipeItem v-for="(item, index) in list" :key="'greegoods-' + index">
            <div
              class="img-wrapper"
              :style="{ backgroundImage: 'url(' + item + ')' }"
            ></div>
          </SwipeItem>
        </Swipe>
      </div>
    </div>
  </div>
</template>

<script>
import { getFreeGoodsList } from '@/api/freeGoods'
import { Swipe, SwipeItem, Icon } from 'vant'
export default {
  components: { Swipe, SwipeItem, Icon },
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      getFreeGoodsList().then((res) => {
        const list = []
        res.data.forEach((item) => {
          const goodList = item.goodsList.map((_item) => _item.good.goodsImg)
          list.push(...goodList)
        })
        this.list = list.slice(0, 5)
      })
    },
  },
}
</script>

<style lang="less" scoped>
.freegoods-container {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 20px 20px 22px;
  .left {
    .title {
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
    }
    .subtitle {
      font-size: 20px;
      font-weight: 400;
      color: #aeaeae;
      line-height: 28px;
    }
    .btn {
      margin-top: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 34px;
      height: 34px;
      width: 74px;
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      line-height: 18px;
      background-color: #e82035;
      .van-icon {
        font-size: 20px;
        line-height: 20px;
      }
    }
  }
  .right {
    padding-top: 22px;
    .swiper-wrapper {
      width: 94px;
      height: 94px;
      .van-swipe {
        height: 100%;
      }
      .img-wrapper {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }
  }
}
</style>